import { useNavigate } from "react-router-dom";
import { getUser } from "../../../helpers/utils";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../../helpers/api";
import { plans, USER_TYPES } from "../../../constant";
import Button from "../../../components/Button";
import { ReactComponent as EmailIcon } from "../../../assets/icons/email.svg";
import { ReactComponent as PersonIcon } from "../../../assets/icons/person.svg";
import { ReactComponent as DotsIcon } from "../../../assets/icons/dots.svg";
import { Tooltip } from "react-tooltip";

import moment from "moment";
import { Panel } from "../../../components/Panel";
import { UserOptionSelect } from "./UserOptionSelect";
import { ConfirmBlock } from "../../users/components/DeactivateModal";
import { ConfirmDelete } from "../../users/components/DeleteUserModal";
import { useState } from "react";

export function Subscribers() {
  const navigate = useNavigate();
  const user = getUser();

  const [isDeactivateModalOpen, setIsDeactivateModalOpen] =
    useState<any>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<any>(false);

  const { data, refetch, isLoading } = useQuery({
    queryKey: ["subscribers"],
    queryFn: () =>
      api.getUsers({ page: 0, limit: 10, type: USER_TYPES.SUBSCRIBERS }),
    enabled: !!user?.id,
  });
  return (
    <>
      <Panel
        label="Recent Subscribers"
        className="flex-1"
        actions={
          <Button
            variant="link"
            className="text-content-secondary underline p-0 m-0 h-fit"
            onClick={() => {
              navigate("/users");
            }}
          >
            View all users
          </Button>
        }
      >
        <div className="h-[calc(100vh-300px)] overflow-auto gap-4 p-4 flex flex-col">
          {data?.map((subscriber) => (
            <Subscriber
              key={subscriber.id}
              subscriber={subscriber}
              onDeactivate={() => {
                setIsDeactivateModalOpen(subscriber.userid);
              }}
              onDelete={() => setIsDeleteModalOpen(subscriber.userid)}
            />
          ))}
        </div>
      </Panel>

      {isDeactivateModalOpen && (
        <ConfirmBlock
          onClose={() => setIsDeactivateModalOpen(false)}
          userId={isDeactivateModalOpen}
          refetch={() => {
            refetch();
          }}
          isActive={true}
        />
      )}
      {isDeleteModalOpen && (
        <ConfirmDelete
          onClose={() => setIsDeleteModalOpen(false)}
          userId={isDeleteModalOpen}
          refetch={() => {
            refetch();
          }}
        />
      )}
    </>
  );
}

function Subscriber({ subscriber, onDeactivate, onDelete }) {
  return (
    <>
      <div className="pl-4 pr-3 py-4 rounded-lg border border-border-secondary justify-between items-center inline-flex">
        <div className="justify-start items-center gap-3 flex">
          <PersonIcon className="w-[46px] h-[46px]" />
          <div className="flex-col justify-start items-start gap-1.5 flex">
            <div className="justify-start items-center gap-1.5 flex">
              <div className="text-content-primary text-sm font-medium font-['Inter'] leading-[14px]">
                {subscriber?.firstname} {subscriber?.lastname}
              </div>
              <div className="justify-start items-start flex">
                <div
                  className={`${
                    plans.find((plan) => plan.type === subscriber?.tier)
                      ?.planStyle
                  } text-xs font-medium leading-3 border rounded py-1 px-1.5 flex items-center justify-center w-fit`}
                >
                  {
                    plans.find((plan) => plan.type === subscriber?.tier)
                      ?.planName
                  }
                </div>
              </div>
              <img
                data-tooltip-id={`experiences-my-tooltip-${subscriber.id}`}
                className="w-[19px] h-[19px] rounded"
                src={
                  subscriber?.pms === "CLOUDBEDS"
                    ? "/images/cloudbeds.png"
                    : "/images/mews.png"
                }
                alt="mews"
              />
              <Tooltip
                id={`experiences-my-tooltip-${subscriber?.id}`}
                className="p-2.5 z-[2] !text-content-tertiary !border border-border-secondary !rounded-md !text-[11px] !bg-surface-primary !shadow-dropdown"
                noArrow
              >
                Connected PMS:{" "}
                <span className="text-content-primary font-semibold text-xs">
                  {subscriber?.pms === "CLOUDBEDS" ? "Cloudbeds" : "Mews"}
                </span>
              </Tooltip>
            </div>
            <div className="justify-start items-center gap-[5px] flex">
              <EmailIcon className="w-5 h-5" />
              <div className="text-content-secondary text-[13px] font-normal flex-1 leading-[13px]">
                {subscriber?.email}
              </div>
            </div>
          </div>
        </div>
        <div className="justify-start items-center gap-3 flex">
          <div className="text-content-secondary text-[11px] font-normal font-['Inter'] leading-[11px]">
            Joined on {moment(subscriber?.joinedon).format("MMM DD, YYYY")}
          </div>
          <UserOptionSelect onDeactivate={onDeactivate} onDelete={onDelete} />
        </div>
      </div>
    </>
  );
}
